import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const tokens = combineTokens("--print-image", {
  maxWidth: units.px(430)
});
const wrapper = "gfxwdsznf7";
const printImage = "gfxp2uucwf";

export { printImage, tokens, wrapper };
import "./image.print.style.linaria.module.css";
//# sourceMappingURL=image.print.style.js.map
